import { PageRef } from 'providers/page-ref';

export type EditExercisePageParams = {
  mode?: string;
  id: string;
  returnCallback?: string;
  local?: {
    returnContext?: unknown;
  };
};

export type EditExercisePageResult = string; // the exercise ID

export const IEditExercisePage: PageRef<EditExercisePageParams, EditExercisePageResult> = {
  pageName: 'EditExercisePage',
} as PageRef<EditExercisePageParams, EditExercisePageResult>;
